<template>
  <div class='buttons BP perfBP'>

    <!-- <el-skeleton style="width: 240px" :loading="loading" animated></el-skeleton> -->

    <div product>
      <img :src="ProductImage"/>
      <ul v-for="(row,index) in KeyMap" :line='index'>
          <li v-for="(item,i) in row" :key="i"  v-on:click="selectItem" 
           :class='{
           "perf":true,
           "select":item.select,
           "uas": getWorkingModeJourney(item.working_mode)}' 

           :working_J_mode="(item.working_mode & 0xF0)"
           :working_mode="(item.working_mode & 0x0F)"
           :journey_global="journey_global" 
           :journey="item.journey_trigger =='-'?item.journey_trigger:item.journey_trigger.toFixed(2)" 
           :rt_down="item.journey_RT.down" 
           :rt_up="item.journey_RT.up" 
           :top_safe="item.safe_zone_top" 
           :bottom_safe="item.safe_zone_bottom" 
           :hid="item.hid"  fn="1" isset="1" j="0" r="0" c="0" v-if="item.key_name"  
           :cname="item.name"  
           :name="item.key_name">
           
              <i class="el-icon-circle-check"></i>
              <i v-if="getWorkingModeJourney(item.working_mode)" >{{item.journey_RT.down}}/{{item.journey_RT.up}}</i>
              <div box v-if="getWorkingModeJourney(item.working_mode)">
                      <h2>{{item.journey_trigger =='-'?item.journey_trigger:item.journey_trigger.toFixed(2)}} (mm)</h2>
                      <p>RT/T：{{item.journey_RT.down}}/{{item.safe_zone_top}}</p>
                      <p>RT/B：{{item.journey_RT.up}}/{{item.safe_zone_bottom}}</p>
              </div>

              <div box v-if="!getWorkingModeJourney(item.working_mode)">
                <h2>{{item.journey_trigger =='-'?item.journey_trigger:item.journey_trigger.toFixed(2)}} (mm)</h2>
                <p>RT/T：关闭/{{item.safe_zone_top}}</p>
                <p>RT/B：关闭/{{item.safe_zone_bottom}}</p>
              </div>

          </li>
      </ul>
    </div>

  </div>
</template>
<script>
// import $ from 'jquery' "select": item.select,
// "has": (item.journey_trigger !=  journey_global && item.journey_trigger != 0 && item.journey_trigger != 2),
import cmd10 from '../../../../../theme/cmd1.0.config.json';
export default {
  name: 'productButtonC',
  components: 
  {

  },
  data() {

    return {
      HIDDeviceObj:null,
	    KeyMap: [],
      indexes:0,
      curIndex:-1,
      ProductImage:null,
      loading: true,
      journey_global:0
    }
  },
  mounted() 
  { 

  },
  methods: 
  {
    getWorkingModeJourney(mode)
    {
        mode = (mode>>4)<<4;
        if(mode == parseInt(cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_MODE_CODE.HRT))
        {
          return true;
        }

        return false;
    },
    setJourneys(hidObj)
    {
      this.journey_global = hidObj.journey_global.toFixed(2);
      this.KeyMap = hidObj.MatrixList.KeyMap;
    },
    //获取设备图片
    setProductImagePath()
    {
        this.loading = false;
        this.ProductImage = require("../../../../drives/" + this.HIDDeviceObj.curDeviceMode + "/asserts/image/product_k.png");   

        import ("../../../../drives/" + this.HIDDeviceObj.curDeviceMode + "/asserts/css/keyboard.css");
        import ("../../../../drives/" + this.HIDDeviceObj.curDeviceMode + "/asserts/css/buttonBGXY.css");
    },
    //选择
    selectItem(el)
    {  
       el.currentTarget.classList.toggle('select');
       
       
       let working_mode =  el.currentTarget.getAttribute("working_mode");

       let journey =  el.currentTarget.getAttribute("journey");
       let rt_up =  working_mode == 0?0:el.currentTarget.getAttribute("rt_up");
       let rt_down =  working_mode == 0?0:el.currentTarget.getAttribute("rt_down");

       let safe_top =  el.currentTarget.getAttribute("top_safe");
       let safe_bottom =  el.currentTarget.getAttribute("bottom_safe");

       
       this.$emit("updateJourney", journey,rt_down,rt_up,safe_top,safe_bottom);

    },
  }
}

</script>